/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-11-12 10:50:10
 * @modify date 2023-11-12 10:50:10
 * @desc [description]
 */

import { ContentContainerProps } from "interfaceTypes/ContentsProps";
import { StyleSheet, View, Text } from "react-native";
import { FONT } from "../../../value/staticValues";
import { useTranslation } from "react-i18next";
import ContentBox from "../../base/tamplate/ContentBox";
import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";
import ListTable from "../../base/table/listTable";
import { parseLocaleDatetime } from "common/util";
import { StorageDetailData, storagePoolTableColumns, svcTableColumns } from "./StorageDetailData";



interface StorageDetailProps extends ContentContainerProps {
    fetchData: any;
    headers: any;
    refreshYn: boolean;
    detailData: StorageDetailData;
}


export default function StorageDetailView(props:StorageDetailProps) {
  const { t } = useTranslation();

  return (
    <ContentBox title={t("STORAGE_DETAIL_TITLE")} subtitle={t("STORAGE_DETAIL_DESC")} infoText={props.infoText} infoError={props.infoError} back={true} >
            <View style={style.topContainer}>
                <View style={{
                    flexDirection: "row", alignItems: "center", justifyContent: "flex-end"
                }}>
                    <View style={{ flexDirection: "row", alignItems: "center" }}>
                        <Text style={style.dateTitle}>
                            {t("LAST_UPDATE_DATE_TEXT")}
                        </Text>
                        <Text style={style.dateData}>
                            {props.detailData.update_ts ? parseLocaleDatetime(props.detailData?.update_ts) : "-"}
                        </Text>
                    </View>
                    <View style={{ flexDirection: "row", alignItems: "center", marginLeft: 30 }}>
                        <Text style={style.dateTitle}>
                            {t("CREATE_DATE_TEXT")}
                        </Text>
                        <Text style={style.dateData}>
                            {props.detailData.create_ts ? parseLocaleDatetime(props.detailData?.create_ts) : "-"}
                        </Text>
                    </View>
                </View>

                <View style={{...style.boxContainer, height: 280}}>
                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 50}}>
                        <Text style={style.boxContentTitle}>
                            {t("BASE_INFO_TEXT")}
                        </Text>
                    </View>
                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                        <Text style={style.boxContentHeaderText}>
                            {t("STORAGE_DETAIL_STORAGE_POOL_NAME")}
                        </Text>
                        <Text style={{...style.boxContentDataText,fontFamily: FONT.MEDIUM, fontSize: 14, marginRight: 14}}>
                            {props.detailData.storage_pool_name ? props.detailData.storage_pool_name : 'ceph@rbd_volumes#rbddriver'}
                        </Text>
                    </View>

                    <View style={{flexDirection: "row"}}>
                        <View style={{width: 490}}>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>

                                <Text style={style.boxContentHeaderText}>
                                    {t("STORAGE_DETAIL_STORAGE_POOL_TYPE")}
                                </Text>
                                <Text style={style.boxContentDataText}>
                                    {props.detailData?.storage_protocol_type_code || "-"}
                                </Text>
                            </View>
                        </View>
                        <View style={{width: 490}}>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>

                                <Text style={style.boxContentHeaderText}>
                                    {t("NETWORK_ACTIVE_STATE_TEXT")}
                                </Text>
                                <View style={{ flexDirection: "row", alignItems: "center",}}>
                                    {
                                        props.detailData?.up_yn ? <StatusStableImg/> : <StatusBlockImg/>
                                    }
                                    <Text style={{
                                        fontFamily: FONT.REGULAR,
                                        fontSize: 12,
                                        color: props.detailData?.up_yn ? "#3a8344" : "#8c8c8c",
                                        marginLeft: 5
                                    }}>
                                        {props.detailData?.up_yn ? 'Up' : 'Down'}
                                    </Text>
                                </View>
                            </View>
                        </View>
                    </View>

                    <View style={{flexDirection: "row"}}>
                        <View style={{width: 490}}>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>

                                <Text style={style.boxContentHeaderText}>
                                {t("STORAGE_DETAIL_STORAGE_POOL_USAGE_SIZE")} / {t("STORAGE_DETAIL_STORAGE_POOL_TOTAL_SIZE")}
                                </Text>
                                <Text style={style.boxContentBlueDataText}>
                                {props.detailData?.storage_pool_allocated_capacity_gb + 'GB' || "0GB"} / {props.detailData?.storage_pool_total_capacity_gb + 'GB' ||  "0GB"} ({typeof (props.detailData?.storage_pool_allocated_capacity_gb / props.detailData?.storage_pool_total_capacity_gb) === "number" ? (props.detailData?.storage_pool_allocated_capacity_gb / props.detailData?.storage_pool_total_capacity_gb * 100).toFixed(2) : 0}%)
                                </Text>
                            </View>
                        </View>
                    </View>
                </View>



                <View style={{...style.boxContainer}}>
                    <View style={{flexDirection: "row", alignItems: "center"}}>
                        <Text style={{...style.boxContentTitle, fontFamily: FONT.REGULAR, color: "#3a3b3f"}}>
                            {t("STORAGE_DETAIL_STORAGE_POOL_SERVICE_INFO")}
                        </Text>
                    </View>
                    <View>
                        <ListTable
                            id={"storagePoolServiceInfo"}
                            searchBarYn={false}
                            pageYn={false}
                            rowCheckYn={false}
                            fetchDataCb={props.fetchData}
                            pageCount={0}
                            pageSize={20}
                            tableHeaders={svcTableColumns}
                            tableData={props.detailData?.services}
                            totalItemCount={0}
                            detailYn={false}
                            refreshYn={props.refreshYn}
                            canLoadYn={false}
                        />
                    </View>
                </View>


                <View style={{...style.boxContainer}}>
                    <View style={{flexDirection: "row", alignItems: "center"}}>
                        <Text style={{...style.boxContentTitle, fontFamily: FONT.REGULAR, color: "#3a3b3f"}}>
                            {t("STORAGE_DETAIL_STORAGE_POOL_INFO")}
                        </Text>
                    </View>
                    <View>
                        <ListTable
                            id={"storagePoolInfo"}
                            searchBarYn={false}
                            pageYn={false}
                            rowCheckYn={false}
                            fetchDataCb={props.fetchData}
                            pageCount={0}
                            pageSize={20}
                            tableHeaders={storagePoolTableColumns}
                            tableData={props.detailData?.pools}
                            totalItemCount={0}
                            detailYn={false}
                            refreshYn={props.refreshYn}
                            canLoadYn={false}
                        />
                    </View>
                </View>
            </View>
        </ContentBox>
  )
}




const style = StyleSheet.create({
    topContainer: {
        width: 1115,
        minHeight: 860,
    },
    boxContainer: {
        marginTop: 20,
        paddingTop: 34, paddingLeft: 50, paddingRight: 40, paddingBottom: 45,
        borderRadius: 8,
        boxShadow: "0 10px 12px 0 rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(0, 0, 0, 0.05)",
        borderStyle: "solid", borderWidth: 1, borderColor: "#e5e9ec",
        backgroundColor: "#fff"
    },
    dateTitle: {
        marginRight: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#8793a3"
    },
    dateData: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#9ea0a5"
    },
    boxContentTitle: {
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        color: "#333"
    },
    boxContentHeaderText: {
        width: 100,
        marginRight: 52,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 12,
        color: "#333"
    },
    boxContentDataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    boxContentBlueDataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#0853fb"
    }
});